import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import EmptyImage from 'src/assets/images/empty-clipboard.svg'
import EmptySearchImage from 'src/assets/images/empty-search.svg'

interface Props {
  /** True when a search term narrows the list, so the copy points at the search, not the data. */
  isSearchUsed: boolean
}

/** Mirrors apps/dashboard's `EmptyContractors`: illustration, h4 title, grey body2 hint. */
const EmptyCustomersComponent = ({ isSearchUsed }: Props) => {
  return (
    <div
      data-testid="customers-list-empty"
      css={tw`flex h-full flex-1 flex-col items-center justify-center`}
    >
      <img src={isSearchUsed ? EmptySearchImage : EmptyImage} alt="" />
      <Typography variant="h4" css={tw`mb-1 mt-2 font-semibold`}>
        {isSearchUsed ? 'No customers found' : 'No customers yet'}
      </Typography>
      <Typography variant="body2" css={tw`text-shades-400`}>
        {isSearchUsed
          ? 'Please try a different search query.'
          : 'No customer records in this tab. Add a new customer to see it listed here.'}
      </Typography>
    </div>
  )
}

export const EmptyCustomers = memo(EmptyCustomersComponent)
